import { useCallback, useContext } from "react";
import { ConsentContext, COOKIE_CATEGORIES } from "./ConsentContext";

const buildAllAccepted = () =>
  Object.fromEntries(Object.keys(COOKIE_CATEGORIES).map((k) => [k, true]));

const buildAllRejected = () =>
  Object.fromEntries(
    Object.entries(COOKIE_CATEGORIES).map(([k, def]) => [k, !!def.locked])
  );

const useConsent = () => {
  const ctx = useContext(ConsentContext);
  if (!ctx) throw new Error("useConsent must be used inside <ConsentProvider>");

  const { consentState, updateConsent, resetConsent, isPanelOpen, setIsPanelOpen, defaultCategories } = ctx;

  const hasCategory = useCallback(
    (cat) => !!consentState?.[cat],
    [consentState]
  );

  const acceptAll = useCallback(() => {
    updateConsent(buildAllAccepted());
  }, [updateConsent]);

  const rejectAll = useCallback(() => {
    updateConsent(buildAllRejected());
  }, [updateConsent]);

  const updateCategories = useCallback(
    (cats) => {
      updateConsent(cats);
      setIsPanelOpen(false);
    },
    [updateConsent, setIsPanelOpen]
  );

  const openPreferences = useCallback(() => {
    setIsPanelOpen(true);
  }, [setIsPanelOpen]);

  const closePreferences = useCallback(() => {
    setIsPanelOpen(false);
  }, [setIsPanelOpen]);

  return {
    consentState,
    hasCategory,
    acceptAll,
    rejectAll,
    updateCategories,
    openPreferences,
    closePreferences,
    resetConsent,
    isPanelOpen,
    defaultCategories,
  };
};

export default useConsent;
